import { ComponentProps, ReactNode } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import {
  UiDialog,
  UiDialogContent,
  UiDialogDescription,
  UiDialogFooter,
  UiDialogHeader,
  UiDialogTitle,
} from '@/ui/UiDialog'
import {
  UiDrawer,
  UiDrawerContent,
  UiDrawerDescription,
  UiDrawerFooter,
  UiDrawerHeader,
  UiDrawerTitle,
} from '@/ui/UiDrawer'
import { UiScrollArea } from '@/ui/UiScrollArea'

type Props = {
  open: boolean
  onOpenChange?: (open: boolean) => void

  title: string
  description?: string
  content: ReactNode
  footer?: ReactNode

  modalProps?: ComponentProps<typeof UiDialog>
  drawerProps?: ComponentProps<typeof UiDrawer>
}

export default function ResponsiveModalDrawer({
  open,
  onOpenChange,

  title,
  description,
  content,
  footer,
  modalProps,
  drawerProps,
}: Props) {
  const isMdUp = useMediaQuery('(min-width: 768px)')

  if (isMdUp) {
    return (
      <UiDialog {...modalProps} open={open} onOpenChange={onOpenChange}>
        <UiDialogContent isWithCloseButton={false}>
          <UiDialogHeader>
            <div className='flex flex-col items-center text-center'>
              <UiDialogTitle>
                <span className='gradient-text typography-m3-headline-medium font-bold'>
                  {title}
                </span>
              </UiDialogTitle>
              {description && (
                <UiDialogDescription>{description}</UiDialogDescription>
              )}
            </div>
          </UiDialogHeader>
          <UiScrollArea className='max-h-[60dvh] overflow-auto'>
            {content}
          </UiScrollArea>
          {footer && <UiDialogFooter>{footer}</UiDialogFooter>}
        </UiDialogContent>
      </UiDialog>
    )
  }

  return (
    <UiDrawer {...drawerProps} open={open} onOpenChange={onOpenChange}>
      <UiDrawerContent className='max-h-[80dvh]'>
        <UiDrawerHeader className='flex items-center justify-between pt-0'>
          <UiDrawerTitle>{title}</UiDrawerTitle>
          {description && (
            <UiDrawerDescription>{description}</UiDrawerDescription>
          )}
        </UiDrawerHeader>

        <UiScrollArea className='overflow-auto p-4'>{content}</UiScrollArea>
        {footer && <UiDrawerFooter>{footer}</UiDrawerFooter>}
      </UiDrawerContent>
    </UiDrawer>
  )
}
